<template>
  <main class="internet_request_notice_modal">
    <div class="modal_wrap bottom_modal" :class="{ on: show }">
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <div class="request_notice_pop">
            <div class="con_1">
              <img
                :src="
                  require('@/assets/front/images/v2/character/img_character_idea.png')
                "
                alt=""
              />
            </div>
            <div class="con_2">
              앗! 오늘 <span>{{ today }}</span> 기준
            </div>
            <div class="con_3">
              인터넷 연장(재약정) 혜택이 거의 없어요!
            </div>
            <div class="con_4">
              통신사 변경으로 견적 받아보시겠어요?
            </div>
            <div class="con_5 pnt">
              <div class="con_txt" @click="joinTypeSel('A')">
                통신사 변경으로 받아보기
              </div>
            </div>
            <div class="con_6 pnt">
              <div class="con_txt" @click="joinTypeSel('B')">
                그대로 진행하기(연장)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import format from 'date-fns/format';

export default {
  name: 'internetJoinNoticeModal',
  components: {},
  props: {
    show: Boolean,
  },
  data() {
    return {
      today: '',
    };
  },
  async created() {
    this.getToday();
  },
  computed: {},
  methods: {
    joinTypeSel(sel) {
      this.$emit('joinTypeSel', sel);
    },
    getToday() {
      this.today = format(new Date(), 'M월 d일');
    },
  },
};
</script>
